import React, { createContext, useCallback, useContext, useState } from 'react';
import { getClientTimezone } from './utils';
const STORAGE_KEY = 'kg_timezone';
const TimezoneContext = createContext(null);
export function TimezoneProvider({ children }) {
    const [timezone, setTimezoneState] = useState(() => {
        var _a;
        try {
            return (_a = localStorage.getItem(STORAGE_KEY)) !== null && _a !== void 0 ? _a : getClientTimezone();
        }
        catch {
            return getClientTimezone();
        }
    });
    const setTimezone = useCallback((tz) => {
        setTimezoneState(tz);
        try {
            localStorage.setItem(STORAGE_KEY, tz);
        }
        catch {
            // localStorage may be unavailable in some environments
        }
    }, []);
    return (React.createElement(TimezoneContext.Provider, { value: { timezone, setTimezone } }, children));
}
export function useTimezone() {
    const ctx = useContext(TimezoneContext);
    if (!ctx)
        throw new Error('useTimezone must be used inside <TimezoneProvider>');
    return ctx;
}
